import delayUnmounting from './delayUnmounting'
import Authorization from './authorization'
import withHover from './withHover'
import styledComponent from './styledComponent'
import withCustomization from './withCustomization'
import withErrorBoundary from './ErrorBoundary'
import {getVal, getValFromTheme} from './styledComponent'

// -> allowed roles to access this route
const UserComponent = Authorization(['employee', 'manager', 'admin'])
const ManagerComponent = Authorization(['manager', 'admin'])
const AdminComponent = Authorization(['admin'])

export {delayUnmounting, styledComponent, getValFromTheme, getVal, Authorization, withCustomization,
    UserComponent, ManagerComponent, AdminComponent, withErrorBoundary, withHover}



// WEBPACK FOOTER //
// ./src/hoc/index.js